import { Component } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-infopopup',
  templateUrl: 'infopopup.html',
  styleUrls: ['infopopup.scss'],
})
export class InfoPopupComponent {
  private page: string;

  constructor( public viewCtrl: PopoverController ) { }

  closeTooltip() {
    this.viewCtrl.dismiss();
  }

  getPopOverData() {
    return this.page;
  }
}
